module.exports = __webpack_public_path__ + "static/img/tkm.2135acc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/tkm.svg
// module id = n4yd
// module chunks = 0